import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { getMultiselectValue } from "@client/lib/settings";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { type GridViewProps } from "@common/controls/GridView/component";
import { connect } from "react-redux";
import Component, { type Props } from "./component";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector(TargetSelector.Entity);
  const visibleColumnsSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "visibleColumns",
    undefined,
    getMultiselectValue
  );

  return <T extends {}, D extends {}, ModalProps = void>(
    state: AppState,
    props: EntityRef & GridViewProps<T, D, ModalProps>
  ): Props<T, D, ModalProps> => {
    return {
      ...props,
      fieldStyle: fieldStyleSelector(state, props),
      visibleColumns: visibleColumnsSelector(state, props)
    };
  };
};

// TODO: figure out to make generics work
const TableViewContainer = connect(makeMapStateToProps)(Component) as React.ComponentType<GridViewProps<any, any, any>>;
export default TableViewContainer;
